<template>
  <v-dialog v-model="dialog" persistent="persistent" max-width="500px"><template v-slot:activator="{ on }"><v-list-tile
        v-on="on"><v-list-tile-title>{{ $t('buttons.makePayment') }}</v-list-tile-title></v-list-tile></template>
    <v-card v-if="invoice">
      <v-card-title><span class="headline" v-if="invoice">{{ $t('labels.payInvoiceNumber') }} {{ invoice.invoiceID
      }}</span></v-card-title>
      <v-card-text>
        <!-- <v-tabs fixed-tabs="fixed-tabs" slider-color="red" v-model="active" dark="dark" color="info">
          <v-tab>{{ $t('labels.stripe') }}</v-tab>
          <v-tab>{{ $t('labels.manual') }}</v-tab>
          <v-tabs-items touchless="touchless">
            <v-tab-item>
              <v-container grid-list-md="grid-list-md">
                <v-layout row="row" wrap="wrap">
                  <v-flex xs6="xs6">
                    <v-select v-model="selectedCard" :items="cards" item-text="last4" item-value="id" attach="attach"
                      :label="$t('labels.selectCard')"></v-select>
                  </v-flex>
                  <v-flex xs6="xs6">
                    <v-text-field class="right-input" v-model="amount" prefix="$" readonly="readonly"
                      label="Amount"></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" :disabled="isloading" flat="flat" @click="close">{{ $t('buttons.cancel')
                  }}</v-btn>
                  <div v-if="!isCardLoading">
                    <v-btn color="blue darken-1" dark="dark" :loading="isloading" @click="saveStripPayment">{{
                      $t('buttons.save') }}</v-btn>
                  </div>
                </v-layout>
              </v-container>
            </v-tab-item>
            <v-tab-item>
              <v-container grid-list-md="grid-list-md">
                <v-layout row="row" wrap="wrap">
                  <v-flex xs6="xs6">
                    <DateTimePicker :showIcon="false" :range="false" :clearable="false" :hideTime="true" label="Date Time"
                      ref="dateTimePicker" v-on:input="setDateTime" :initStartDate="$moment(new Date())" :noFuture="true">
                    </DateTimePicker>
                  </v-flex>
                  <v-flex xs6="xs6">
                    <v-autocomplete :items="comboBoxByID(10).ComboBoxDetails" :label="$t('labels.paymentMethod')"
                      item-text="selector" item-value="id" v-model="manual.paymentTypeID"></v-autocomplete>
                  </v-flex>
                  <v-flex xs6="xs6">
                    <v-text-field v-model="manual.stripePaymentID" :error-messages="transactionNumberErrors"
                      label="Transaction"></v-text-field>
                  </v-flex>
                  <v-flex xs6="xs6">
                    <v-text-field class="right-input" v-model="amount" prefix="$" readonly="readonly"
                      label="Amount"></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" :disabled="isloading" flat="flat" @click="close">{{ $t('buttons.cancel')
                  }}</v-btn>
                  <v-btn color="blue darken-1" :disabled="manualSaveBtnStatus" dark="dark" :loading="isloading"
                    @click="saveManualPayment">{{ $t('buttons.save') }}</v-btn>
                </v-layout>
              </v-container>
            </v-tab-item>
          </v-tabs-items>

        </v-tabs> -->
        <v-container grid-list-md="grid-list-md">
                <v-layout row="row" wrap="wrap">
                  <v-flex xs6="xs6">
                    <DateTimePicker :showIcon="false" :range="false" :clearable="false" :hideTime="true" label="Date Time"
                      ref="dateTimePicker" v-on:input="setDateTime" :initStartDate="$moment(new Date())" :noFuture="true">
                    </DateTimePicker>
                  </v-flex>
                  <v-flex xs6="xs6">
                    <v-autocomplete :items="comboBoxByID(10).ComboBoxDetails" :label="$t('labels.paymentMethod')"
                      item-text="selector" item-value="id" v-model="manual.paymentTypeID"></v-autocomplete>
                  </v-flex>
                  <v-flex xs6="xs6">
                    <v-text-field v-model="manual.stripePaymentID" :error-messages="transactionNumberErrors"
                      label="Transaction"></v-text-field>
                  </v-flex>
                  <v-flex xs6="xs6">
                    <v-text-field class="right-input" v-model="amount" prefix="$" readonly="readonly"
                      label="Amount"></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" :disabled="isloading" flat="flat" @click="close">{{ $t('buttons.cancel')
                  }}</v-btn>
                  <v-btn color="blue darken-1" :disabled="manualSaveBtnStatus" dark="dark" :loading="isloading"
                    @click="saveManualPayment">{{ $t('buttons.save') }}</v-btn>
                </v-layout>
              </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import invoiceService from "../service.js";
import locationService from "../../Location/service.js";
import DateTimePicker from "../../Global/components/DateTimePicker";
import { mapGetters, mapActions } from "vuex";
const { validationMixin } = require("vuelidate");
const { required, minLength } = require("vuelidate/lib/validators");

export default {
  props: ["invoice"],
  data() {
    return {
      amount: 1,
      isCardLoading: false,
      manual: {
        paidDateTime: new Date(),
        stripePaymentID: null,
        paymentTypeID: 59,
        collectStripe: 0
      },
      isloading: false,
      manualSaveBtnStatus: false,
      active: 1,
      selectedCard: null,
      dialog: false,
      cards: []
    };
  },
  mixins: [validationMixin],
  validations: {
    manual: {
      stripePaymentID: {
        required,
        minLength: minLength(4)
      }
    }
  },
  components: {
    DateTimePicker
  },
  watch: {
    cards(val) {
      if (val) this.selectedCard = val[0].id;
    },
    dialog(val) {
      // console.log(this.selectedInvoice);
      // if (this.invoice.Store.autoCollect) {
      //   this.active = 0;
      // } else {
      //   this.active = 1;
      // }
      if (val) {
        this.amount = (parseFloat(this.invoice.invoiceAmount) + parseFloat(this.invoice.taxAmount)).toFixed(2);
        this.getCard();
      }
    }
  },
  computed: {
    ...mapGetters("global", ["comboBoxByID", "currentUser"]),
    transactionNumberErrors() {
      const errors = [];
      if (!this.$v.manual.stripePaymentID.$dirty) return errors;
      if (!this.$v.manual.stripePaymentID.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.manual.stripePaymentID.minLength)
        errors.push(this.$t("validations.fieldMustbeatLeast4ChrLong"));
      return errors;
    }
  },
  methods: {
    saveStripPayment() {
      this.isloading = true;
      let data = {
        cardId: this.selectedCard
      };
      return invoiceService
        .collectInvoice(this.invoice.invoiceID, data)
        .then(result => {
          this.isloading = false;
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000
            })
            .fire({
              type: "success",
              title: "Payment was collected successfully"
            });
          // this.setLocation(this.invoice.Store.storeID);
          this.empty();
          this.$emit("save");
          this.dialog = false
        })
        .catch(err => {
          this.isloading = false;
          this.$swal("Declined", err.data.data, "error");
          this.$emit("refresh");
          this.dialog = false
        });
    },
    saveManualPayment() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000
          })
          .fire({
            type: "error",
            title: this.$t("toastMessage.text.invalidFields")
          });
      } else {
        this.isloading = true;
        return invoiceService
          .chargeManual(this.invoice.invoiceID, this.manual)
          .then(result => {
            console.log("result charge", result);
            this.isloading = false;
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000
              })
              .fire({
                type: "success",
                title: "Payment was collected successfully"
              });
            // this.setLocation(this.invoice.Store.storeID);
            this.empty();
            this.$emit("save");
            this.dialog = false
          }).catch(err => {
            this.isloading = false;
            this.$swal('Error', err.data.data, 'error')
          })
      }
    },
    empty() {
      this.manual = {
        paidDateTime: new Date(),
        stripePaymentID: null,
        paymentTypeID: 59,
        collectStripe: 0
      };
      this.$v.$reset;
    },
    close() {
      this.empty();
      this.dialog = false
    },
    getCard() {
      if (this.invoice.Store.stripeID) {
        this.isCardLoading = true;
        locationService
          .getCardByStore(this.invoice.Store.storeID)
          .then(response => {
            if (response.status) {
              this.cards = response.data.sources.data;
              this.isCardLoading = false;
            } else {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000
                })
                .fire({
                  type: "error",
                  title: response.data
                });
            }
          })
          .catch(error => {
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000
              })
              .fire({
                type: "error",
                title: error.data
              });
          });
      }
    },
    setDateTime(val) {
      this.manual.paidDateTime = val;
    },
    makePayment() {
      this.isloading = true;
      let userData = {
        cardId: this.selectedCard
      };
      creditCardService
        .collectInvoice(this.invoice.invoiceID, userData)
        .then(result => {
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000
            })
            .fire({
              type: "success",
              title: "Payment Collected"
            });
          this.isloading = false;
          this.$emit("refresh");
          this.cancel();
        })
        .catch(err => {
          console.log(err);
          this.isloading = false;
          this.$swal("Pay Invoice", err.data.data, "error");
        });
    }
  }
};
</script>

<style scoped>.v-dialog__container {
  display: none !important;
}</style>
